import wx from 'weixin-js-sdk'
// import wx from 'http://res2.wx.qq.com/open/js/jweixin-1.4.0.js'
// var wx = window.jWeixin || {} // 做处理
function wxConfig(conf) {
    // console.log('wx',window.jWeixin)
    // wx.config({})
    // wx.hideAllNonBaseMenuItem()     // 隐藏所有非基础按钮接口 https://mp.weixin.qq.com/wiki?t=resource/res_main&id=mp1421141115
    console.log(window.jWeixin)
    wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: conf.app_id, // 必填，公众号的唯一标识
        timestamp: '' + conf.timestamp, // 必填，生成签名的时间戳
        nonceStr: conf.noncestr, // 必填，生成签名的随机串
        signature: conf.signature, // 必填，签名，见附录1
        // appId: 'wx4d5db4ca1b6b0f00',
        // noncestr: 'JPT2MZQHJFPNR9BM6XMSP3KKWRPYRVES',
        // signature: '2ccbdb51f0ee3f21fb02d8724a605310d6ac4ab6',
        // timestamp: 1538321288,
        // url: 'http://api-staging.mryitao.cn/vip/collectMoney',
        jsApiList: [
            'scanQRCode',
            'chooseWXPay',
            'closeWindow',
            'onMenuShareAppMessage',
            'onMenuShareQQ',
            'onMenuShareWeibo',
            'onMenuShareQZone',
            "onMenuShareTimeline",
            // 'menuItem:share:timeline',
            // 'menuItem:copyUrl'
        ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2 上线删除 menuItem:copyUrl
    })
}

function wxReady(cb) {
    wx.ready(function () {
        typeof cb === 'function' && cb()
    })
}

function wxErr(cb) {
    wx.error(function (res) {
        typeof cb === 'function' && cb(res)
    })
}

function closeWindow() {
    wx.closeWindow();
}
/**
 * 微信扫码
 * @param {Function} res // 扫描结果回调函数
 */
function wxScanQrCode(result) {
    wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: [
            'qrCode'
        ], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) { // 当needResult 为 1 时，扫码返回的结果
            typeof result === 'function' && result(res)
        }
    })
}

/**
 * 调起微信支付
 * @param {*} payData //支付数据
 * @param {*} cb
 */
function wxPay(payData, cb) {
    wx.chooseWXPay({
        timestamp: payData.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        nonceStr: payData.nonceStr, // 支付签名随机串，不长于 32 位
        package: payData.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
        signType: payData.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        paySign: payData.paySign, // 支付签名
        success: function (res) {
            typeof cb === 'function' && cb(res, 'success')
        },
        cancel: function (res) {
            typeof cb === 'function' && cb(res, 'cancel')
        },
        fail: function (res) {
            typeof cb === 'function' && cb(res, 'fail')
        }
    })
}

/**
 * 微信分享给朋友
 */
function wxShareAppMessage(obj) {
    wx.onMenuShareAppMessage({
        title: obj.title || '每日一淘',
        desc: obj.desc || '每日一淘商城',
        link: obj.link || 'https://mryt-mall.mryitao.cn/vip',
        imgUrl: obj.imgUrl || 'https://image.mryitao.cn/0/20190910110636.png',
        fail: function (res) {
            // alert(JSON.stringify(res))
        }
    })
}
/**
 * 微信分享到朋友圈
 */
function wxShareTimeline() {
    wx.onMenuShareAppMessage({
        title: '每日优鲜便利购',
        link: 'https://blg.mishfresh.cn/blg',
        imgUrl: 'http://grampus-qrcode.ufile.ucloud.cn/15768283fee4439ca1670ab9e6f51475_missfresh_blg_logo5.png',
        fail: function (res) {
            // alert(JSON.stringify(res))
        }
    })
}

export default {
    wxConfig: wxConfig,
    wxScanQrCode: wxScanQrCode,
    wxPay: wxPay,
    wxShareAppMessage: wxShareAppMessage,
    wxShareTimeline: wxShareTimeline,
    wxReady: wxReady,
    closeWindow: closeWindow,
    wxErr: wxErr
}



// WEBPACK FOOTER //
// ./src/utils/wx_service.js